const action = 'ENABLE_SHOP';

const attempt = () => {
  const result = {
    success: true
  };

  return result;
};

const executeSideEffects = (context, result) => {
  const { party } = context;
  const { history } = party;

  history.add({ action, result }, context);

  return {};
};

const enableShop = notifyDone => ({
  title: 'OK',
  enabled: () => true,
  execute: context => {
    const result = attempt(context);
    executeSideEffects(context, result);

    notifyDone();

    return {};
  }
});

export default enableShop;
